import { createApiClient } from './http';
import { Response } from '../entities/Response';
import { ScriptExecution, ScriptExecutionCommandType, ScriptExecutionRunResult, ScriptExecutionServer } from '../entities/SslScript';

const apiClient = createApiClient({ timeoutInMills: 300000 });

export default class ScriptExecutionService {
    static async getScript(request: { environment: string; scriptName: string }): Promise<ScriptExecution | null> {
        const response = await apiClient.post('/service/script-execution/get', request);
        return response.data;
    }

    static async updateScript(request: { id: number; scriptPath: string; content: string; environment: string; scriptName: string }): Promise<Response<ScriptExecution>> {
        return await apiClient.post('/service/script-execution/update', request);
    }

    static async listServers(request: { environment: string; scriptName: string }): Promise<ScriptExecutionServer[]> {
        const response = await apiClient.post('/service/script-execution/server/list', request);
        return response.data || [];
    }

    static async deployScript(request: { environment: string; scriptName: string; allServers: boolean; serverIps: string[] }): Promise<ScriptExecutionRunResult[]> {
        const response = await apiClient.post('/service/script-execution/deploy', request);
        return response.data || [];
    }

    static async runScript(request: {
        environment: string;
        scriptName: string;
        allServers: boolean;
        serverIps: string[];
        commandType: ScriptExecutionCommandType;
        command: string;
        deployBeforeRun: boolean;
    }): Promise<ScriptExecutionRunResult[]> {
        const response = await apiClient.post('/service/script-execution/run', request);
        return response.data || [];
    }
}
